//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import React from 'react';
import styled from 'styled-components';

import { PrimaryLinkButton } from '@components/atoms/button/Button';
import { BodyText, TitleText } from '@components/atoms/text/Text';
import { ContentDrawerTrackingIds } from '@content-drawer/contentDrawerConstants';
import empty from '@images/empty_content.svg';

export interface EmptyMediaPageProps {
  onResetFilters: () => void;
}

export const EmptyMediaPage = ({ onResetFilters }: EmptyMediaPageProps) => {
  return (
    <Wrapper>
      <Image src={empty} alt='Empty page' />
      <TitleText>No results found.</TitleText>
      <BodyText>
        Remove some of your filters,
        <Link
          onClick={onResetFilters}
          trackingId={ContentDrawerTrackingIds.RESET_FILTERS}
        >
          or start over.
        </Link>
      </BodyText>
    </Wrapper>
  );
};

const Wrapper = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacings[2]};
    margin: ${theme.spacings[5]};
    padding: ${theme.spacings[5]};
    border: ${theme.borderWidths[1]} solid ${theme.colors.gray1};
    border-radius: ${theme.borderRadii[2]};
    background: ${theme.colors.gray0};
  `,
);

const Image = styled.img(
  ({ theme }) => `
    margin: ${theme.spacings[5]};
  `,
);

const Link = styled(PrimaryLinkButton)(
  ({ theme }) => `
    padding-left: ${theme.spacings[1]};
  `,
);
